import { useEffect, useState } from "react";
import CategoryTagComponent from "../../Misc/CategoryTag/CategoryTagComponent";
import "./TagGroup.scss";
import { useDispatch, useSelector } from "react-redux";
import { getCategoryByEntityID } from "../../../../redux/assignCourse/actions";
import { SessionKeys } from "../../../../utils/AppUtils";
import _ from "lodash";
import ShimmerScreen from "../../../Layouts/ShimmerScreen";
import { getTags, getTagsClear } from "../../../../redux/courses/actions";

const TagGroup = (props) => {
  const { id, code, source, type, isMobile } = props;

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [catTagsArray, setCatTagsArray] = useState([1, 2, 3]);

  // const categoryListByEntityId = useSelector(
  //   (state) => state.assignCourse.categoryListByEntityId
  // );
  console.log("tagsdata", id, source, type);
  const categoryListByEntityId = useSelector((state) => state.courses.tagsData);

  useEffect(() => {
    if (id && type && source) {
      setIsLoading(true);
      dispatch(
        getTags({
          module: "getTagsData",
          postData: {
            entity_id: id,
            entity_type: type,
            origin: "xsel",
          },
        })
      );
    }
    return () => {
      dispatch(getTagsClear());
    };
  }, [dispatch, id, source, type]);

  useEffect(() => {
    console.log("tags data--", categoryListByEntityId);
    if (!_.isEmpty(categoryListByEntityId)) {
      if (categoryListByEntityId.status === "success") {
        const payload = categoryListByEntityId.payload.payload;
        if (!_.isEmpty(payload)) {
          setCatTagsArray(
            payload.map((p) => {
              return {
                id: p.entity_id,
                name: p.name,
              };
            })
          );
        } else {
          setCatTagsArray([]);
        }
      } else {
        setCatTagsArray([]);
      }
      setIsLoading(false);
    }
  }, [categoryListByEntityId]);

  useEffect(() => {
    console.log("cattags--", catTagsArray);
  }, [catTagsArray]);

  return (
    <div className="tag-sec">
      {isLoading ? (
        <>
          <div className="tag-title">
            <ShimmerScreen case={"rect"} height="5" width="10" />
          </div>
        </>
      ) : _.isEmpty(catTagsArray) || catTagsArray.length === 0 ? (
        ""
      ) : (
        <>
          {" "}
          <div className="tag-title">Tags</div>
          <div className="tag-group">
            {catTagsArray.map((tag, i) => {
              return (
                <CategoryTagComponent
                  catId={tag.id}
                  name={tag.name}
                  key={`cat-tags-${i + 1}`}
                  isLoading={isLoading}
                  isMobile={isMobile}
                />
              );
            })}
          </div>{" "}
        </>
      )}
    </div>
  );
};

export default TagGroup;
